import underscore from 'underscore';

const _ = (window._sv = underscore.noConflict());

export default _;
